import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import ReactDOM from "react-dom";
import AppRoutes from './AppRoutes';
import { Layout } from './components/Layout';
import './custom.css';
import jQuery from 'jquery';
import $ from 'jquery'

/////*< !--Libraries Stylesheet-- >*/
//import './assets/lib/owlcarousel/assets/owl.carousel.min.css';
import './assets/lib/animate/animate.min.css';

/////*< !--JavaScript Libraries-- >*/
//import './assets/lib/wow/wow.min.js';
//import './assets/lib/easing/easing.min.js';
//import './assets/lib/waypoints/waypoints.min.js';
//import './assets/lib/counterup/counterup.min.js';
//import './assets/lib/owlcarousel/owl.carousel.min.js';

///*<!--Template Javascript-- >*/
//import '../assets/js/main.js';

export default class App extends Component {
  static displayName = App.name;

  render() {
    return (
      <Layout>
        <Routes>
          {AppRoutes.map((route, index) => {
            const { element, ...rest } = route;
            return <Route key={index} {...rest} element={element} />;
          })}
        </Routes>
      </Layout>
    );
  }
}
